import "../agreement.css";

const Terms = () => {
    return (
        <div className="terms-wrapper">
            <span>서비스이용약관</span>
            <br />
            <span>주식회사 액츠 서비스이용약관</span>
            <br />
            <span>제 1장 총칙</span>
            <br />
            <span>제 1조 목적</span>
            <br />
            <span>
                본 약관은 주식회사 액츠(이하 "회사"라고 합니다)이 제공하는 온라인 및 모바일 비즈니스 관련 제반 서비스(이하 "ACTS29"라고 합니다)의
                이용과 관련하여 “회원”과 "회사"간에 필요한 권리, 의무 및 책임사항, 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.
            </span>
            <br />
            <span>제 2조 정의</span>
            <br />
            <span>① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</span>
            <br />
            <span>
                1. "ACTS29"라 함은 "회원"이 이용자를 대상으로 하는 비즈니스 활동 과정에서 사용할 수 있도록 “회사”가 제공하는 비즈니스 관련 제반 서비스
                일체를 말합니다.
            </span>
            <br />
            <span>2. “회사”는 다음 각 목의 "ACTS29"의 관련 서비스를 제공합니다. 또한, 이러한 서비스를 통칭하여 “ACTS29 통합 서비스”라 말합니다.</span>
            <br />
            <span>가. 29mall</span>
            <br />
            <span>나. 시더스페이</span>
            <br />
            <span>다. 시더스온</span>
            <br />
            <span>3. “회원”이라 함은 본 약관에 따라 “회사”와 이용계약을 체결하고, “회사”가 제공하는 “ACTS29”를 이용하는 고객을 말합니다.</span>
            <br />
            <span>
                4. "권한설정"이라 함은 "회원"이 갖는 개별 “ACTS29”의 접근 및 관리 등에 필요한 권한의 일부 또는 전부를 다른 “회사”에게 위탁하는 것을
                말합니다.
            </span>
            <br />
            <span>
                5. “회원계정”이란 “회사”가 제공하는 통합로그인계정을 이용하기 위해 [서비스이용약관] 동의를 통해 “회사”와 통합로그인계정 이용계약을
                체결하고, “회사”로부터 부여받은 로그인계정을 말합니다.
            </span>
            <br />
            <span>
                6. "ACTS29"란 “회원”이 “ACTS29”에서 활동하기 위해 “회사”에서 일정 기준에 맞춰 지급받게되며, “SHOPPING”, “INVEST” 등의 서비스를 함께
                활용할 수 있는 가상자산을 말합니다.
            </span>
            <br />
            <span>
                7. “탈퇴”라 함은 “회원”의 잔여 “ACTS29”의 유/무를 확인하여 “회원”혹은 “회사”자산 등의 내용을 모두 정리한 이후 영구적 탈퇴를 말합니다.
            </span>
            <br />
            <span>
                8. “API”라 함은 Application Programming Interface의 약자로서 “회원”의 애플리케이션 등에서 “회사”가 제공하는 기술을 사용하기 위한
                인터페이스를 말합니다.
            </span>
            <br />
            <span>9 "소속"이라 함은 본 약관에서 정하는 바에 따라 “회원”이 소속된 플랫폼을 확인하기 위한 단어를 말합니다</span>
            <br />
            <span>
                10. "동행자"라 함은 “회원”의 추천을 통해 “ACTS29”에 “회원가입”을 하여 “회원계정”을 보유하고있으며, 실제 “ACTS29”를 이용하고 있는
                “회원”을 말합니다
            </span>
            <br />
            <span>
                ② 본 약관에서 사용되는 용어 중 본 조에서 정하지 아니한 사항은 "ACTS29"의 ACTS29 운영약관(이하 "ACTS29 운영약관"이라 합니다)과 일반
                상관례 및 관련 법령에서 정하는 바에 따릅니다.
            </span>
            <br />
            <span>제 3조 약관의 게시와 개정</span>
            <br />
            <span>① “회사”는 본 약관의 내용을 “회원”이 쉽게 알 수 있도록 "ACTS29"의 회원가입 화면을 통하여 게시합니다.</span>
            <br />
            <span>② "회사"는 필요한 경우 관련법령을 위반하지 않는 범위 내에서 본 약관을 개정할 수 있습니다.</span>
            <br />
            <span>
                ③ "회사"는 본 약관을 개정할 경우에는 기존 약관과 개정 약관의 적용 일자와 개정 사유를 명시하여 현행 약관과 함께 개별 “ACTS29”의
                초기화면 또는 공지사항 등에서 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 개정 내용이 "회원"에게 불리한 경우에는 그
                적용일자 30일전부터 개별 통지합니다.
            </span>
            <br />
            <span>
                ④ "회사"가 전항에 따라 공지하면서 "회원"에게 적용일자 전 일까지 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게
                공지하거나 통지하였음에도 "회원"이 명시적으로 거부 의사표시를 하지 않은 경우 "회원"이 개정 약관에 동의 한 것으로 봅니다.
            </span>
            <br />
            <span>⑤ "회원"은 개정 약관에 동의하지 않는 경우 적용일자 전 일까지 "회사"에 거부 의사를 표시하고 "회원" 탈퇴를 할 수 있습니다.</span>
            <br />
            <span>제 4조 회원에 대한 통지</span>
            <br />
            <span>
                ① "회사"가 "회원"에 대하여 통지를 하는 경우 본 약관에 별도의 규정이 없는 한 "회원"이 제공한 전자우편, (휴대)전화(SMS 포함) 등의
                수단으로 할 수 있습니다.
            </span>
            <br />
            <span>
                ② "회사"는 "회원"의 전체에 대한 통지의 경우 7일 이상 개별 "ACTS29" 내 공지 게시판 등에 게시함으로써 제1항의 통지를 갈음 할 수
                있습니다. 다만, “회원” 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 제1항의 통지를 합니다.
            </span>
            <br />
            <span>
                ③ "회원"은 "회사"에 실제로 연락이 가능한 전자우편, (휴대)전화번호, 회원계정ID 등의 정보를 제공하고 해당 정보들을 최신으로 유지하여야
                하며, "회사"의 통지를 확인하여야 합니다.
            </span>
            <br />
            <span>
                ④ "회사"는 “회원”의 연락처 미기재, 변경 후 미수정 등으로 인하여 개별 통지가 어려운 경우에 한하여 제2항 본문의 공지를 함으로써 개별
                통지한 것으로 간주하며, “회원”의 제3항에 따른 의무 를 소홀히 하여 발생한 불이익에 대해서는 보호받지 못합니다.
            </span>
            <br />
            <span>제2장 회원 가입 및 ACTS29의 이용</span>
            <br />
            <span>제 5조 회원 가입</span>
            <br />
            <span>
                ① "회원" 가입은 "회원"이 되고자 하는 자(이하 "가입신청자"라고 합니다)가 약관의 내용에 대하여 동의를 한 다음 "회사"가 정한 절차에 따라
                가입신청을 하고 이를 "회사"가 승낙함으로써 가입이 완료됩니다.
            </span>
            <br />
            <span>
                ② "회사"는 "가입신청자"에 대해 승낙함을 원칙으로 합니다. 다만, "회사"는 다음 각 호의 사유가 있는 경우에는 승낙을 하지 않을 수 있으며,
                가입 이후에도 다음 각 호의 사유가 확인될 경우 직권으로 즉시 이용 계약을 해지할 수 있습니다.
            </span>
            <br />
            <span>
                1. "가입신청자"가 본 약관 및 “ACTS29 운영약관” 위반 등을 이유로 이전에 "회원" 자격을 상실한 적이 있거나, 이용 제한 중 "회원" 탈퇴 후
                재가입 신청을 하는 경우
            </span>
            <br />
            <span>2. 실명이 아니거나 타인의 명의를 이용한 경우</span>
            <br />
            <span>3. 허위 또는 잘못된 정보를 기재 또는 제공하거나 "회사"가 제시하는 사항을 기재하지 않은 경우</span>
            <br />
            <span>4. 미성년자는 가입이 불가능함</span>
            <br />
            <span>
                5. "가입신청자"의 귀책사유로 인하여 승낙이 불가능하거나 기타 본 약관 및 “ACTS29 운영약관” 에서 규정한 제반 사항을 위반하여 신청하는
                경우
            </span>
            <br />
            <span>6. "회사"의 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우</span>
            <br />
            <span>
                ③ "회사"는 본 조 제1항에 따른 신청에 대하여 제시한 사항에 대해 확인 및 검증을 할 수 있으며 전문기관을 통한 실명 확인 및 본인 인증 또는
                증빙서류 제출을 "가입신청자"에게 요청할 수 있습니다.
            </span>
            <br />
            <span>④ "회원" 가입의 성립 시기는 "회사"가 가입 완료를 신청 절차 상에서 표시한 시점으로 합니다.</span>
            <br />
            <span>제 6조 ACTS29의 이용</span>
            <br />
            <span>
                ① "회원" 가입이 완료되면 “회원”은 “회사”가 정한 절차와 기준에 따라 "회사"에서 제공하는 "ACTS29"를 자유롭게 이용할 수 있습니다. 다만,
                “회사”는 ”ACTS29” 이용과 관련하여 필요한 경우 별도의 약관 동의, 추가 정보의 제공 또는 “회사”에서 정한 인증 및 심사절차 등의 완료를
                요구할 수 있습니다.
            </span>
            <br />
            <span>
                ② 제6조에 따른 “회원” 가입에도 불구하고, “ACTS29 운영약관”에서 정하는 바에 따라 “회원”의 “ACTS29” 일부 이용이 제한될 수 있습니다.
            </span>
            <br />
            <span>
                ③ "회사"는 더 나은 "ACTS29"의 제공을 위해 "회원"에게 “ACTS29”의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한 다양한
                정보를 개별 "ACTS29"의 공지사항 표기, 전자우편, (휴대)전화(SMS 포함) 등을 통해 제공하는 서비스 영역 내 표시 등의 방법으로 제공할 수
                있습니다. 다만, 광고성 정보 전송의 경우에는 사전에 “회원”이 수신에 동의한 경우에만 전송합니다.
            </span>
            <br />
            <span>④ 개별 "ACTS29"에서 제공하는 서비스의 구체적인 내용은 “ACTS29 운영약관”을 통해 더 자세히 확인할 수 있습니다.</span>
            <br />
            <span>제 7조 권한설정</span>
            <br />
            <span>① “회사”는 개별 “ACTS29”에서 갖는 권한을 다른 회원에게 “권한설정”을 할 수 있습니다.</span>
            <br />
            <span>② "회원"은 전항의 “권한설정”과 관련하여 본 약관 또는 “ACTS29 운영약관”에서 정하는 바에 따릅니다.</span>
            <br />
            <span>③ “권한설정”을 통한 다른 “회원”의 “ACTS29” 이용 행위는 권한을 위탁한 “회원”의 행위로 인정됩니다.</span>
            <br />
            <span>제 8조 서비스의 변경</span>
            <br />
            <span>① "회사"는 안정적인 "ACTS29" 제공을 위하여 "ACTS29"의 내용, 운영상 또는 기술상 사항 등</span>
            <br />
            <span>
                ② "회사"는 "ACTS29"를 변경할 경우 변경 내용과 적용 일자를 명시하여 해당하는 서비스에서 사전에 공지합니다. 다만, "회원"의 권리나 의무
                및 "ACTS29" 이용과 관련되는 실질적인 사항을 변경할 경우 적용일자 7일 전부터 공지하며, "회원"에게 불리한 변경의 경우 적용일자 30일
                전부터 공지합니다.
            </span>
            <br />
            <span>③ "회원"은 "ACTS29"의 변경에 동의하지 않을 경우 "회사"에 거부 의사를 표시하고 "회원"탈퇴를 할 수 있습니다.</span>
            <br />
            <span>제 9조 서비스의 중단</span>
            <br />
            <span>
                ① "회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체, 고장, 통신두절 등의 불가항력적인 사유가 발생한 경우에는 "ACTS29" 제공을 일시적으로
                중단할 수 있습니다.
            </span>
            <br />
            <span>
                ② 제1항의 경우 "회사"는 "회원"에게 사전에 통지하여 "회원"의 불이익을 최소화하기 위해 노력합니다. 다만, "회사"가 사전에 통지할 수 없는
                불가피한 사유가 있는 경우 사후에 통지할 수 있습니다.
            </span>
            <br />
            <span>
                ③ "회사"는 사업적 판단에 따라 "ACTS29"의 일부 또는 전부 중단을 결정할 수 있으며, 이와 관련하여 정당한 사유가 없는 한 "회원"이 서비스
                이용에 따라 기대하는 이익에 대한 손실을 보상하지 않습니다.
            </span>
            <br />
            <span>
                ④ "회원"이 "ACTS29" 내 등록된 정보, 이미지, 게시물 등에 대해서는 "회원"이 스스로 백업하여 서비스 중단에 따른 삭제 시 피해가 없도록
                해야 합니다.
            </span>
            <br />
            <span>⑤ "회원"이 자격을 상실하거나 탈퇴 시 “ACTS29”의 제공이 이루어지지 않을 수 있습니다.</span>
            <br />
            <span>⑥ 본 조의 서비스 중단으로 인하여 발생한 "회원"의 손해에 대하여 "회사"는 고의 또는 과실이 없는 한 책임을 부담하지 않습니다.</span>
            <br />
            <span>제3장 계약 당사자의 권리 및 의무</span>
            <br />
            <span>제 10조 회원의 정보 관리에 대한 의무</span>
            <br />
            <span>
                ① "회원"은 “회원계정”과 비밀번호의 관리에 대한 의무와 책임이 있으며 "회원"은 비밀번호가 도용되거나 제3자의 이용과 같은 부정사용을
                인지한 경우, 이를 즉시 "회사"에 통지하고 "회사"의 안내에 따라야 합니다.
            </span>
            <br />
            <span>
                ② "회원"은 언제든지 가입정보에서 본인의 개인정보를 열람하고 수정할 수 있으며 "회원"이 "회원" 가입 신청 시 기재한 사항이 변경할 경우
                "회사"에 그 변경사항이 알려질 수 있습니다.
            </span>
            <br />
            <span>
                ③ 위 항을 준수하지 않아 발생한 모든 결과에 대한 책임은 "회원" 본인에게 있으며 불이익에 대해 "회사"는 책임을 부담하지 않습니다.
            </span>
            <br />
            <span>제 11조 개인정보보호의 보호</span>
            <br />
            <span>
                ① “회사”는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법령이 정하는 바에 따라 “회원”의 개인정보를 보호하기
                위해 노력합니다.
            </span>
            <br />
            <span>
                ② 개인정보의 보호 및 사용에 대해서는 관련 법령 및 “회사”의 개인정보처리방침이 적용됩니다. 다만, “회사”의 공식 사이트 이외의 링크된
                사이트에서는 “회사”의 개인정보처리방침이 적용되지 않습니다.
            </span>
            <br />
            <span>제 12조 회사의 권리, 의무</span>
            <br />
            <span>① "회사"는 관련 법령과 본 약관을 준수하여 계속적이고 안정적으로 "ACTS29"를 제공하기 위하여 최선을 다하여 노력합니다</span>
            <br />
            <span>
                ② "회사"는 "회원"이 안전하게 "ACTS29"를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위하여 보안시스템을 갖추어야 하며,
                개인정보처리방침을 공시하고 준수합니다.
            </span>
            <br />
            <span>
                ③ "회사"는 "ACTS29" 이용과 관련하여 "회원"으로부터 제기된 의견이 정당 하다고 인정될 경우 이를 처리하여야 하며, 해당 "ACTS29" 내
                게시판, 문의사항 등을 통하여 "회원"에게 처리 과정 및 결과를 전달할 수 있습니다.
            </span>
            <br />
            <span>제 13조 회원의 의무</span>
            <br />
            <span>
                ① "회원"은 관련 법령, 본 약관, “ACTS29 운영약관”, 세부지침, 이용안내 및 "회사"가 공지하거나 통지한 사항 등을 준수하여야 하며, 기타
                "회사"의 업무에 방해되는 행위를 하여서는 안됩니다.
            </span>
            <br />
            <span>② "회원"은 어떠한 경우에도 아래와 같은 행위를 하여서는 안됩니다.</span>
            <br />
            <span>1. "회사"가 제공하지 않은 방식으로 "ACTS29"에 접속하지 않고 비정상적인 방법으로 “ACTS29”를 이용하거나 시스템에 접근하는 행위</span>
            <br />
            <span>2. 에이전트, 로봇, 스크립트, 스파이더, 스파이웨어 등의 수단을 제작, 배포, 설치하거나 이를 유도하는 행위</span>
            <br />
            <span>3. 리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의 가공행위를 통하여 “ACTS29”를 복제,분해 또는 모방 기타 변형하는 행위</span>
            <br />
            <span>
                4. "회원" 가입 또는 "회원" 정보 변경 시, 허위 사실을 기재하거나 다른 "회원" 또는 개인의 개인정보, 비밀번호, 계좌정보 등을 무단으로
                수집하거나 부정하게 사용하는 행위
            </span>
            <br />
            <span>
                5. “ACTS29”의 정상적인 운영을 고의로 방해하거나 방해할 수 있는 정보 및 수신자의 명시적인 동의 없이 광고성 정보를 전송하는 행위
            </span>
            <br />
            <span>
                6. 저작권 침해, 음란 및 폭력물, 타인의 명예를 손상시키거나 기타 공공질서 및 미풍양속에 반하는 게시물을 등록하거나 광고, 프로그램을
                만드는 행위
            </span>
            <br />
            <span>7. 기타 불법적이거나 부당한 방법으로 “회사”의 업무를 방해하는 행위</span>
            <br />
            <span>8. 그 외 "ACTS29 운영약관"에서 명시된 금지행위를 하거나 "ACTS29"의 정상적인 운영을 방해하는 행위</span>
            <br />
            <span>③ "회원"은 "ACTS29" 이용과정에서 취득한 일체의 정보를 제3자에게 제공, 공개 또는 누설하여서는 안 됩니다.</span>
            <br />
            <span>
                ④ “회원”은 경제적 수익활동 등의 이유로 “ACTS29”를 제 3자에게 소개하고 “회원”에게 소속된 “동행자”를 만들게 되었을 경우 개인정보 보호와
                관련하여 다음 각 호의 사항을 모두 준수하여야 합니다. 만약 본 항의 의무를 위반한 것을 “회사”가 인지하게 되는 경우 “회사”는 해당
                “회원”의 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
            </span>
            <br />
            <span>1. “회사”가 제공하는 개인정보를 송수신 시 암호화 처리할 것</span>
            <br />
            <span>2. “회원”의 “동행자” 탈퇴 시 “동행자”와의 활동을 위해 보유하고 있던 모든 개인정보 파기할 것</span>
            <br />
            <span>
                3. 기타 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 개인정보의 보호와 관련된 법령상 “회원”의 의무사항을 성실히 준수할 것
            </span>
            <br />
            <span>
                4. 이용자 데이터를 수집/분석할 수 있는 기술 또는 “API”를 사용하는 과정에서 “회원”이 “회사”에게 이용자의 데이터를 제공한 경우, “회원”은
                개인정보위수탁 계약 체결 또는 개인정보 제3자 제공 동의 절차를 포함한 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등
                관계 법령, 유관 기관의 지침, 가이드라인 등을 준수해야 합니다.
            </span>
            <br />
            <span>
                5. 전항의 데이터가 개인정보에 해당할 경우, “회원”은 개인정보보호법 제17조 제1항에 따라 “회원”의 이용자로부터 개인정보 제3자 제공
                동의를 받아야 합니다.
            </span>
            <br />
            <span>
                ⑤ "회원"은 "ACTS29" 제공 또는 본 조 위반여부를 확인하기 위해 "회사"가 자료 또는 접근권한의 제공 및 관련 사실에 대한 소명을 요청하는
                경우에는 이를 성실히 임하여야 합니다.
            </span>
            <br />
            <span>
                ⑥ "회원"이 "회사"의 귀책 없이 본 약관 또는 관련 법령을 위반하여 제3자가 "회사"를 상대로 민형사상 등의 문제를 제기하는 경우 "회원"은
                해당 문제 해결을 위해 적극 협조하여야 하며, 이와 관련하여 "회사"에 손해가 발생한 경우 손해를 배상합니다.
            </span>
            <br />
            <span>제 14조 권리의 귀속 및 저작물의 이용</span>
            <br />
            <span>
                ① "회사"가 제공하는 “ACTS29” 및 “ACTS29”에서 제공하는 모든 서비스와 관련된 모든 상표, 서비스 마크, 로고 등에 관한 저작권 기타
                지적재산권은 “회사”가 갖습니다.
            </span>
            <br />
            <span>
                ② "회사"는 "회원"이 게시한 콘텐츠를 "회사"가 제공하는 "ACTS29"를 포함한 시더스ON, 시더스페이 등("회사"가 제공하는 "API"를 활용한
                가상자산 관련 서비스)에 노출할 수 있으며, 이와 관련된 프로모션 등에도 노출할 수 있습니다. 해당 노출을 위해 필요한 범위 내에서는 일부
                수정, 복제, 편집할 수 있습니다.
            </span>
            <br />
            <span>
                ③ "회사"는 저작권법 규정을 준수하며, "회원"은 언제든지 “회사”의 고객센터 또는 문의사항을 통해 저작권법 위반 콘텐츠에 대해 삭제, 비공개
                등의 조치를 요청할 수 있습니다.
            </span>
            <br />
            <span>
                ④ "회사"가 "회원"에 대해 "ACTS29"를 제공하는 것은 본 약관에 정한 목적 하에서 “회사”가 허용한 방식으로 “ACTS29”에 대한 이용권한을
                부여하는 것이며, "회원"은 “ACTS29”를 소유하거나 “ACTS29”에 관한 저작권을 보유하게 되는 것이 아닙니다.
            </span>
            <br />
            <span>
                ⑤ "회사"는 "회사"가 정한 이용조건에 따라 "회원"에게 "ACTS29"를 이용할 수 있는 이용권 한만을 부여하며, "회원"은 해당 권리를 제3자에게
                양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.
            </span>
            <br />
            <span>
                ⑥ “회사”는 “회원”의 “ACTS29” 이용 사실을 소개하기 위한 목적으로 “회원”의 이름, 로고, 콘텐츠를 별도의 비용 없이 게시할 수 있습니다.
                다만, “회원”의 요청 시 상호 협의 하에 게시를 중단하거나 수정하여 다시 게재할 수 있습니다.
            </span>
            <br />
            <span>제 4장 이용중단 및 이용제한 등</span>
            <br />
            <span>제 15조 이용중단</span>
            <br />
            <span>① “회원”은 “ACTS29 운영약관”에서 정하는 바에 따라 이용 중인 개별 “ACTS29”의 이용중단을 신청할 수 있습니다.</span>
            <br />
            <span>
                ② “회원”이 전항에 따라 개별 “ACTS29”의 이용 중단을 요청한 경우 “회원”은 이용 중단시점까지 발생한 개별 “ACTS29” 이용에 따른 “출금금액,
                29mall 사용금액 등”을 납부하여야 합니다. 자세한 내용은 “ACTS29 운영약관”에 기재된 지침을 따릅니다.
            </span>
            <br />
            <span>제 16조 이용제한 등</span>
            <br />
            <span>
                ① "회사"는 "회원"이 관련 법령, 본 약관 또는 “ACTS29 운영약관”에 따른 의무를 위반하거나 “회원”의 “ACTS29” 이용이 다음 각 호에 해당할
                경우 "ACTS29"의 이용제한 또는 계약의 해지(이하 "이용제한"이라고 합니다)를 할 수 있습니다.
            </span>
            <br />
            <span>1. “회사”에 법률적 또는 재산적 위험을 발생시키거나 발생시킬 우려가 있는 경우</span>
            <br />
            <span>2. “회사”의 명예?평판?신용이나 신뢰도를 훼손하거나 훼손할 우려가 있는 경우</span>
            <br />
            <span>3. “ACTS29”의 품질을 저하시키거나 저하시킬 우려가 있는 경우</span>
            <br />
            <span>4. 기타 “회사”의 정상적인 서비스 운영을 방해하는 경우</span>
            <br />
            <span>② "이용제한"의 구체적인 기준과 내용 및 절차 등은 “ACTS29 운영약관” 등 "회사"에서 정한 별도의 기준에 따릅니다.</span>
            <br />
            <span>
                ③ "회사"가 "이용제한"을 한 경우 "회원"이 "회사"와 이용계약을 체결하고 이용하는 "회사"의 다른 서비스에 대하여도 이용을 제한하거나
                이용계약을 해지할 수 있으며, "회사"의 다른 서비스에서 이용이 제한되거나 계약이 해지된 경우에도 "ACTS29"의 이용을 제한하거나 이용계약을
                해지할 수 있습니다.
            </span>
            <br />
            <span>
                ④ "회사"는 "이용제한"을 하는 경우 제5조에 정한 방법으로 "회원"에게 통지합니다. 이 경우 "회사"는 "이용제한"을 하기 전에 상당한 기간을
                정하여 "회원"에게 이의신청의 기회를 부여하며, 다만, "ACTS29 운영약관" 등에서 정하는 사유가 있을 경우엔 별도의 이의 신청 기간을
                부여하지 않을 수도 있습니다.
            </span>
            <br />
            <span>
                ⑤ "회원"은 본 조에 따라 "이용제한"을 받은 경우 "회사"가 정하는 절차에 따라 이의신청을 할 수 있습니다. "회사"는 "회원"의 이의가 정당
                하다고 인정될 경우 즉시 "이용제한"을 취소합니다.
            </span>
            <br />
            <span>제 17조 회원의 휴면</span>
            <br />
            <span>"회원"이 법령에서 정하는 기간 동안 “회원”계정 로그인 혹은 접속한 기록이 없는 경우, ACTS29 휴면 정책에 따라 처리합니다.</span>
            <br />
            <span>제 18조 회원의 탈퇴</span>
            <br />
            <span>
                ① "회원"은 언제든지 본 약관 제5조에 따라 가입한 "회원" 탈퇴를 신청할 수 있으며, "회사"는 관련 법령이 정하는 바에 따라 이를 즉시
                처리하여야 합니다. 다만, "ACTS29 운영약관"에 따라 요건이 충족 되어야만 "회원" 탈퇴 처리가 됩니다.
            </span>
            <br />
            <span>② "ACTS29"에서 "회원" 탈퇴 시, "ACTS29 통합 서비스"와 관련된 모든 부분에서 일괄 "회원" 탈퇴가 이뤄집니다.</span>
            <br />
            <span>
                ③ "회원" 탈퇴가 완료되는 경우, "회사"는 관련 법령 및 개인정보처리방침에 따라 보유하는"회원"의 정보를 제외한 "회원"의 모든 정보를 즉시
                삭제합니다. 다만, “회원”이 각 “ACTS29” 내에서 작성한 게시물 등 모든 데이터의 삭제와 관련한 사항은 “ACTS29 운영약관”에 따릅니다.
            </span>
            <br />
            <span>④ "회원" 탈퇴 가 완료되는 경우 "ACTS29 운영약관"에서 정하는 바에 따라 탈퇴 한 "회원"의 재가입이 영구적 제한될 수 있습니다.</span>
            <br />
            <span>제 19조 손해배상 등</span>
            <br />
            <span>
                ① "회사"는 관련 법령상 허용되는 한도 내에서 "ACTS29"와 관련하여 본 약관에 명시되지 않은 어떠한 구체적인 사항에 대한 약정이나 보증을
                하지 않습니다.
            </span>
            <br />
            <span>
                ② "회사"는 "ACTS29" 이용과 관련하여 "회사"의 고의 또는 과실로 인하여 "회원"이 손해를 입게 될 경우 본 약관 및 관련 법령에 따라
                "회원"에게 그 손해를 배상합니다. 다만, "회사"는 "회사"의 과실 없이 발생한 아래와 같은 손해에 대해서는 책임을 부담하지 않습니다. 또한
                "회사"는 법률상 허용 되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해 및 징벌적 손해에 대한 책임을 부담하지 않습니다.
            </span>
            <br />
            <span>1. 천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해</span>
            <br />
            <span>2. "회원"의 귀책사유로 "ACTS29" 이용에 장애가 발생한 경우</span>
            <br />
            <span>3. "ACTS29"에 접속 또는 이용 과정에서 발생하는 개인적인 손해</span>
            <br />
            <span>4. 제 3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써 발생하는 손해</span>
            <br />
            <span>5. 제 3자가 "회사" 서버에 대한 전송 또는 "회사" 서버로부터의 전송을 방해함으로써 발생하는 손해</span>
            <br />
            <span>6. 전송 된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등 제 3자가 서비스를 이용하는 과정에서 발생 된 손해</span>
            <br />
            <span>7. 기타 “회사”의 고의 또는 과실이 없는 사유로 인해 발생한 손해</span>
            <br />
            <span>
                ③ "회사"는 "회사"의 과실이 없는 한 "회원" 상호간 또는 "회원"과 제 3자 상호간에 "ACTS29"를 매개로 발생한 분쟁에 대해서는 개입할 의무가
                없으며 이로 인한 손해를 배상할 책임도 없습니다.
            </span>
            <br />
            <span>
                ④ “회원”이 본 약관 또는 관련법령을 위반하여 “회사”에 손해가 발생한 경우 관련법령이 규정하는 범위 내에서 “회사”에게 그 손해를
                배상합니다.
            </span>
            <br />
            <span>제 20조 책임 제한</span>
            <br />
            <span>
                ① "회사"는 "회원"이 "ACTS29"를 통하여 제공한 게시물, 광고, 정보, 서비스 등에 대한 신뢰도,정확성, 적법성 등에 관하여는 책임을 지지
                않습니다.
            </span>
            <br />
            <span>② "회사"는 무료로 제공되는 서비스 이용과 관련하여 관련 법령에 특별한 규정이 없는 한 책임을 부담하지 않습니다.</span>
            <br />
            <span>제 21조 분쟁의 해결</span>
            <br />
            <span>① "회사"와 "회원" 간 제기된 소송은 대한민국법을 준거법으로 합니다.</span>
            <br />
            <span>② "회사"와 "회원" 간 발생한 분쟁에 관한 소송에 관한 관할법원은 서울중앙지방법원으로 한다.</span>
            <br />
            <span>부칙</span>
            <br />
            <span>1. 본 약관은 2024년 10월 23일부터 시행됩니다.</span>
            <br />
        </div>
    );
};

export default Terms;
